import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import { useNavigate } from 'react-router-dom';
import logger from "../../../utils/logger";
import TelegramNotificationsPanel from './TelegramNotificationsPanel';
import EntityCell from '../EntityCell';
function AdminSupport() {
  const {
    request
  } = useApi();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('tickets');
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    status: '',
    priority: ''
  });
  useEffect(() => {
    loadTickets();
  }, [filter]);
  const loadTickets = async () => {
    setLoading(true);
    try {
      let url = '/api/v1/admin/support/tickets?limit=50';
      if (filter.status) url += `&status=${filter.status}`;
      if (filter.priority) url += `&priority=${filter.priority}`;
      const data = await request(url);
      setTickets(data || []);
    } catch (error) {
      logger.error('Не удалось загрузить тикеты', error);
    } finally {
      setLoading(false);
    }
  };
  const confirmReferralPayout = async (ticketId, e) => {
    e.stopPropagation();
    if (!window.confirm('Подтвердить списание средств со счёта?')) return;
    try {
      await request(`/api/v1/admin/support/tickets/${ticketId}/referral-confirm-payout`, {
        method: 'POST'
      });
      await loadTickets();
    } catch (error) {
      logger.error('Ошибка при подтверждении выплаты', error);
    }
  };
  const getStatusStyle = status => {
    const styles = {
      open: {
        background: '#e74c3c',
        color: 'white'
      },
      pending: {
        background: '#f39c12',
        color: 'white'
      },
      closed: {
        background: '#95a5a6',
        color: 'white'
      }
    };
    return styles[status] || styles.open;
  };
  const getPriorityStyle = priority => {
    const styles = {
      high: {
        background: '#c0392b',
        color: 'white'
      },
      normal: {
        background: '#3498db',
        color: 'white'
      },
      low: {
        background: '#27ae60',
        color: 'white'
      }
    };
    return styles[priority] || styles.normal;
  };
  const formatDate = isoString => {
    const date = new Date(isoString);
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  return <div className="admin-page">
            <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    }}>
                <h1>Техподдержка</h1>
            </div>

            <div style={{
      display: 'flex',
      gap: '10px',
      marginBottom: '20px'
    }}>
                <button
                  type="button"
                  className="button"
                  onClick={() => setActiveTab('tickets')}
                  style={{
                    background: activeTab === 'tickets' ? '#3498db' : '#f0f0f0',
                    color: activeTab === 'tickets' ? 'white' : '#333'
                  }}
                >
                  Тикеты
                </button>
                <button
                  type="button"
                  className="button"
                  onClick={() => setActiveTab('telegram')}
                  style={{
                    background: activeTab === 'telegram' ? '#3498db' : '#f0f0f0',
                    color: activeTab === 'telegram' ? 'white' : '#333'
                  }}
                >
                  🔔 Telegram-каналы
                </button>
            </div>

            {activeTab === 'telegram' && <TelegramNotificationsPanel />}

            {activeTab === 'tickets' && <>
            <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '20px'
      }}>
                <div style={{
        display: 'flex',
        gap: '10px'
      }}>
                    <select value={filter.status} onChange={e => setFilter({
          ...filter,
          status: e.target.value
        })} style={{
          padding: '8px',
          borderRadius: '4px',
          border: '1px solid #ddd'
        }}>
            
                        <option value="">Все статусы</option>
                        <option value="open">Открытые</option>
                        <option value="pending">В ожидании</option>
                        <option value="closed">Закрытые</option>
                    </select>
                    <select value={filter.priority} onChange={e => setFilter({
          ...filter,
          priority: e.target.value
        })} style={{
          padding: '8px',
          borderRadius: '4px',
          border: '1px solid #ddd'
        }}>
            
                        <option value="">Все приоритеты</option>
                        <option value="high">Высокий</option>
                        <option value="normal">Обычный</option>
                        <option value="low">Низкий</option>
                    </select>
                </div>
            </div>

            <div style={{
      background: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      overflow: 'hidden'
    }}>
                <table style={{
        width: '100%',
        borderCollapse: 'collapse'
      }}>
                    <thead style={{
          background: '#f8f9fa',
          borderBottom: '2px solid #e9ecef'
        }}>
                        <tr>
                            <th style={{
              padding: '12px',
              textAlign: 'left'
            }}>Тема</th>
                            <th style={{
              padding: '12px',
              textAlign: 'center'
            }}>Статус</th>
                            <th style={{
              padding: '12px',
              textAlign: 'center'
            }}>Приоритет</th>
                            <th style={{
              padding: '12px',
              textAlign: 'right'
            }}>Обновлен</th>
                            <th style={{
              padding: '12px',
              textAlign: 'center'
            }}>Действие</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && <tr>
                                <td colSpan="4" style={{
              padding: '20px',
              textAlign: 'center'
            }}>Загрузка...</td>
                            </tr>}
                        {!loading && tickets.length === 0 && <tr>
                                <td colSpan="4" style={{
              padding: '20px',
              textAlign: 'center'
            }}>
                                    Нет тикетов
                                </td>
                            </tr>}
                        {tickets.map(ticket => <tr key={ticket.id} style={{
            borderBottom: '1px solid #e9ecef',
            cursor: 'pointer'
          }} onClick={() => navigate(`/admin/support/${ticket.id}`)}>
              
                                <td style={{
              padding: '12px'
            }}>
                                    <EntityCell
                                        name={ticket.subject}
                                        owner={ticket.user_email}
                                        id={ticket.id}
                                    />
                                </td>
                                <td style={{
              padding: '12px',
              textAlign: 'center'
            }}>
                                    <span style={{
                padding: '4px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                ...getStatusStyle(ticket.status)
              }}>
                                        {ticket.status === 'open' ? 'Открыт' : ticket.status === 'pending' ? 'В работе' : 'Закрыт'}
                                    </span>
                                </td>
                                <td style={{
              padding: '12px',
              textAlign: 'center'
            }}>
                                    <span style={{
                padding: '4px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                ...getPriorityStyle(ticket.priority)
              }}>
                                        {ticket.priority === 'high' ? 'Высокий' : ticket.priority === 'low' ? 'Низкий' : 'Обычный'}
                                    </span>
                                </td>
                                <td style={{
              padding: '12px',
              textAlign: 'right',
              color: '#666'
            }}>
                                    {formatDate(ticket.updated_at)}
                                </td>
                                <td style={{
              padding: '12px',
              textAlign: 'center'
            }}>
                                    {ticket.ticket_type === 'referral_withdrawal' && ticket.status === 'open' && <button type="button" className="button button--sm" style={{background: '#27ae60', color: 'white'}} onClick={(e) => confirmReferralPayout(ticket.id, e)}>
                                        Списание прошло
                                    </button>}
                                </td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
            </>}
        </div>;
}
export default AdminSupport;
